import { render, staticRenderFns } from "./VsmeDiversity.vue?vue&type=template&id=094cc324&scoped=true"
import script from "./VsmeDiversity.vue?vue&type=script&lang=js"
export * from "./VsmeDiversity.vue?vue&type=script&lang=js"
import style0 from "./VsmeDiversity.vue?vue&type=style&index=0&id=094cc324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094cc324",
  null
  
)

export default component.exports